<script setup lang="ts">
import device from '@@/bits/device'
import { isAppUsing } from '@@/bits/flip'
import type { WallGroupPost } from '@@/types'
import SurfacePostGroupHeaderSection from '@@/vuecomponents/SurfacePostGroupHeaderSection.vue'
import SurfacePostGroupHeaderSectionOld from '@@/vuecomponents/SurfacePostGroupHeaderSectionOld.vue'

defineProps<{
  section: WallGroupPost
}>()
</script>

<template>
  <SurfacePostGroupHeaderSection
    v-if="isAppUsing('groupPostsV2')"
    :section="section"
    :hide-buttons="true"
    :x-more-button="false"
    :x-rounded-start="true"
    :class="[!device.ios && '-rotate-1']"
  />
  <SurfacePostGroupHeaderSectionOld
    v-else
    :section="section"
    :hide-buttons="true"
    :x-more-button="false"
    :x-rounded-start="true"
    :class="[!device.ios && '-rotate-1']"
  />
</template>
